"use strict";
exports.isBrowser = true;
exports.isNode = false;
//# sourceMappingURL=env.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-universal/browser/env.js
// module id = 586
// module chunks = 1